import { render, staticRenderFns } from "./FamousCommentListFormWeb.vue?vue&type=template&id=cbf63670&"
import script from "./FamousCommentListFormWeb.vue?vue&type=script&lang=js&"
export * from "./FamousCommentListFormWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports